import { render } from "./gjldmx.vue?vue&type=template&id=2070d0ce&scoped=true"
const script = {}

import "./gjldmx.vue?vue&type=style&index=0&id=2070d0ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2070d0ce"]])

export default __exports__